import { render, staticRenderFns } from "./withdrawAddress.vue?vue&type=template&id=712a55b8&scoped=true"
import script from "./withdrawAddress.vue?vue&type=script&lang=js"
export * from "./withdrawAddress.vue?vue&type=script&lang=js"
import style0 from "./withdrawAddress.vue?vue&type=style&index=0&id=712a55b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a55b8",
  null
  
)

export default component.exports